import "core-js/modules/es.array.iterator.js";
import React from 'react';
export const useFileReaderDataUrl = file => {
  const [dataUrl, setDataUrl] = React.useState(null);
  const [loading, setLoading] = React.useState(Boolean(file));
  const [error, setError] = React.useState(false);
  const [progress, setProgress] = React.useState(null);
  const init = React.useCallback(() => {
    const reader = new FileReader();
    reader.onload = () => {
      setDataUrl(reader.result);
      setLoading(false);
    };
    reader.onerror = () => setError(true);
    reader.onprogress = e => {
      const totalLength = e.lengthComputable ? e.total : null;
      if (totalLength) {
        setProgress({
          loaded: e.loaded,
          total: totalLength,
          percentage: Math.round(e.loaded * 100 / totalLength)
        });
      }
    };
    return reader;
  }, []);
  React.useEffect(() => {
    if (file) {
      setLoading(true);
      const reader = init();
      reader.readAsDataURL(file);
    }
  }, [file]);
  return {
    loading,
    dataUrl,
    error,
    progress
  };
};
export const useFileReaderArrayBuffer = file => {
  const [arrayBuffer, setArrayBuffer] = React.useState(null);
  const [loading, setLoading] = React.useState(Boolean(file));
  const [error, setError] = React.useState(false);
  const [progress, setProgress] = React.useState(null);
  const init = React.useCallback(() => {
    const reader = new FileReader();
    reader.onload = () => {
      setArrayBuffer(reader.result);
      setLoading(false);
    };
    reader.onerror = () => setError(true);
    reader.onprogress = e => {
      const totalLength = e.lengthComputable ? e.total : null;
      if (totalLength) {
        setProgress({
          loaded: e.loaded,
          total: totalLength,
          percentage: Math.round(e.loaded * 100 / totalLength)
        });
      }
    };
    return reader;
  }, []);
  React.useEffect(() => {
    if (file) {
      setLoading(true);
      const reader = init();
      reader.readAsArrayBuffer(file);
    }
  }, [file]);
  return {
    loading,
    arrayBuffer,
    error,
    progress
  };
};
export const useFileReaderText = file => {
  const [text, setText] = React.useState(null);
  const [loading, setLoading] = React.useState(Boolean(file));
  const [error, setError] = React.useState(false);
  const [progress, setProgress] = React.useState(null);
  const init = React.useCallback(() => {
    const reader = new FileReader();
    reader.onload = () => {
      setText(reader.result);
      setLoading(false);
    };
    reader.onerror = () => setError(true);
    reader.onprogress = e => {
      const totalLength = e.lengthComputable ? e.total : null;
      if (totalLength) {
        setProgress({
          loaded: e.loaded,
          total: totalLength,
          percentage: Math.round(e.loaded * 100 / totalLength)
        });
      }
    };
    return reader;
  }, []);
  React.useEffect(() => {
    if (file) {
      setLoading(true);
      const reader = init();
      reader.readAsText(file);
    }
  }, [file]);
  return {
    loading,
    text,
    error,
    progress
  };
};